import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * SEO — a small wrapper around react-helmet-async that sets the standard
 * title + description + Open Graph + Twitter Card tags for every public page.
 * Keeps meta consistent (site name, twitter handle, og:image fallback).
 */
export default function SEO({
  title,
  description,
  path = "",
  image = null,
  type = "website",
}) {
  const siteName = "DAP — Every deal starts with a DAP";
  const url = typeof window !== "undefined" ? `${window.location.origin}${path || window.location.pathname}` : "";
  const fullTitle = title ? `${title} · DAP` : siteName;
  const desc = description || "The Creator Business OS. Live media kit, AI contract review, deal copilot, and the insider Playbook Library — free to start.";
  const ogImage = image || `${typeof window !== "undefined" ? window.location.origin : ""}/og-default.png`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="DAP" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}
